<template>
  <div>
    <app-spinner v-if="!loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        :key="table_key"
        :class="{ 'table-default--loading': table_preloader }"
        class="table-default"
      >
        <template #h__vendor><div class="table-default__left">Vendor</div></template>
        <template #h__number><div class="table-default__left">Plate number</div></template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowDeleteModal(row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
        <template #date="{ row }">{{ dateTimeFormat(row.date) }}</template>
        <template #number="{ row }"><div class="table-default__left">{{ row.invalid_car }}</div></template>
        <template #car="{ row }">
          <app-select
            @input="onSelectCar(row)"
            v-model="row.car"
            :options="cars_options"
            :clearable="false"
            :display-field="option => `${option.car_model.name} (${option.plate_number})`"
            label="plate_number"
            placeholder="Cars"
            class="select--250"
          />
        </template>
        <template #odometer="{ row }">{{ row.odometer.toLocaleString() }} km</template>
        <template #amount="{ row }">{{ row.amount.toLocaleString() }} TSh</template>
        <template #type="{ row }">{{ row.fuel_type }}</template>
        <template #vendor="{ row }"><div class="table-default__left">{{ row.vendor.name }}</div></template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
    <modal
      name="delete"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete item
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteLog" ref="deleteLog">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteCarManagementFuelLog,
  getCarManagementCars,
  getCarManagementFuelLogs,
  patchCarManagementFuelLog,
} from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'CarManagementFuelLogInvalidList',
  data() {
    return {
      loaded: false,
      table_preloader: false,
      table: {
        items: [],
        columns: [
          'controls',
          'date',
          'number',
          'car',
          'odometer',
          'amount',
          'type',
          'vendor',
        ],
        options: {
          headings: {
            controls: '',
            date: 'Date',
            number: 'Plate number',
            car: 'Car',
            odometer: 'Odometer',
            amount: 'Amount',
            type: 'Fuel type',
            vendor: 'Vendor',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_key: 0,
      cars_options: [],
      log_to_delete: null,
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchItems()
      })
    }, 0)
    getCarManagementCars().then(response => { this.cars_options = response.data })
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getCarManagementFuelLogs({
        page: this.pagination.page,
        page_size: 40,
        invalid_record: true,
      })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.table_key += 1
          this.table_preloader = false
          this.loaded = true
        })
    },
    onSelectCar(row) {
      this.table_preloader = true
      patchCarManagementFuelLog(row.id, {car: row.car.id})
        .then(() => {
          this.fetchItems()
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onShowDeleteModal(event_id) {
      this.log_to_delete = event_id
      this.$modal.show('delete')
    },
    onDeleteLog() {
      this.$refs.deleteLog.preload = true
      this.table_preloader = true
      deleteCarManagementFuelLog(this.log_to_delete)
        .then(() => {
          this.fetchItems()
          this.$modal.hide('delete')
          this.$notify({
            type: 'success',
            title: 'Item deleted',
          })
        })
        .catch(() => {
          this.$refs.deleteLog.preload = false
        })
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
